import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ArrowRight } from "lucide-react";
import * as Icons from "lucide-react";
import { Badge } from "@/components/ui/badge";

export function ConditionCard({ condition, testId }) {
    const { t } = useTranslation();
    const Icon = Icons[condition.icon] || Icons.Activity;
    return (
        <Link
            to={`/conditions/${condition.slug}`}
            data-testid={testId || `condition-card-${condition.slug}`}
            className="card-soft group flex flex-col gap-3 p-6 transition-shadow duration-200 h-full"
        >
            <div className="flex items-start justify-between gap-3">
                <div className="inline-flex h-10 w-10 items-center justify-center rounded-xl bg-[color:var(--brand-teal-soft)] text-[color:var(--brand-teal-2)]">
                    <Icon className="h-5 w-5" />
                </div>
                <Badge variant="secondary" className="bg-[color:var(--bg-subtle)] text-[color:var(--text-soft)] text-[10px] uppercase tracking-wider">
                    {condition.category}
                </Badge>
            </div>
            <h3 className="font-display text-lg font-semibold text-[color:var(--brand-navy)]">
                {condition.name}
            </h3>
            <p className="text-sm text-[color:var(--text-muted)] leading-relaxed line-clamp-3">
                {condition.summary}
            </p>
            <div className="mt-auto inline-flex items-center gap-1.5 text-sm font-semibold text-[color:var(--brand-teal-2)] group-hover:gap-2 transition-[gap]">
                {t("cta.readMore")}
                <ArrowRight className="h-4 w-4" />
            </div>
        </Link>
    );
}
